import {
  loadScript
} from "./chunk-JUQXCWMV.mjs";
import "./chunk-NDCDZYN6.mjs";
export {
  loadScript
};
//# sourceMappingURL=loadScript.mjs.map